import React, { useState } from 'react';
import './home.scss';
import { convertDateToDateString } from '../../util/dates';
import CreateLessonModal from './CreateLessonModal';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useGetAcademies } from '../../hooks/api/academy';
import DefaultLessonsView from './DefaultLessonsView';
import InstructorDesktopLessonsView from './InstructorDesktopLessonsView';
import { useCurrentUser } from '../../hooks/useCurrentUser';

const DEFAULT_ACADEMY_ID = 35;

export default function HomePage() {
  const [date, setDate] = useState(convertDateToDateString(new Date()));
  const [academy, setAcademy] = useState(DEFAULT_ACADEMY_ID);
  const [isCreateLessonModalOpen, setIsCreateLessonModalOpen] = useState(false);

  const { data: academies } = useGetAcademies();
  const { currentUserId, isInstructor, isLoadingCurrentUser } = useCurrentUser();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isInstructorDesktop = isInstructor && isDesktop;

  if (!currentUserId || isLoadingCurrentUser) return null;

  return (
    <Box
      className="lesson-times-container"
      sx={{
        textAlign: isInstructorDesktop ? 'left' : 'center',
        margin: isInstructorDesktop ? 0 : undefined,
      }}
    >
      <CreateLessonModal
        isOpen={isCreateLessonModalOpen}
        close={() => setIsCreateLessonModalOpen(false)}
      />

      {isInstructorDesktop ? (
        <InstructorDesktopLessonsView
          academies={academies ?? []}
          academyId={academy}
          date={date}
          onAcademyChange={setAcademy}
          onCreateLesson={() => setIsCreateLessonModalOpen(true)}
          onDateChange={setDate}
        />
      ) : (
        <DefaultLessonsView
          academies={academies ?? []}
          academyId={academy}
          date={date}
          isInstructor={isInstructor}
          onAcademyChange={setAcademy}
          onCreateLesson={() => setIsCreateLessonModalOpen(true)}
          onDateChange={setDate}
          userId={currentUserId.toString()}
        />
      )}
    </Box>
  );
}
